





















import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { IPageExtendBehavior } from "../../../../../documaker/domain/format/objects";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";

@Component({
  components: {
    OptionDropDownSelector,
  }
})
export default class PageExtendBehaviorEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: IPageExtendBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IPageExtendBehavior) => T, defaultValue: T) => T;

  get isFontSizeThresholdEnable(): boolean {
    return this.readPropertyOrDefault(s => s.isEnable, false);
  }

  set isFontSizeThresholdEnable(value: boolean) {
    this.writePropertyWhenValid(s => s.isEnable = value);
  }

  get fontSizeThreshold(): number {
    return this.readPropertyOrDefault(s => s.fontSizeThreshold, 8);
  }

  set fontSizeThreshold(value: number) {
    this.writePropertyWhenValid(s => s.fontSizeThreshold = value);
  }

  get shouldMoveAllText(): boolean {
    return this.readPropertyOrDefault(s => s.shouldMoveAllText, true);
  }

  set shouldMoveAllText(value: boolean) {
    this.writePropertyWhenValid(s => s.shouldMoveAllText = value);
  }

  thresholdOptions: StandardOption<number>[] = Enumerable.from([
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    14,
    16,
    18,
    20,
    22,
    24,
    26,
    28,
    36,
    48,
    72,
    108,
    156,
    216,
  ]).select(i => new StandardOption<number>(i.toString(), i)).toArray();
}
